import React from 'react'
import UploadFileDropzoneChip from '@podcastsoundboard/ps-lib/components/UploadFileDropzoneChip'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Chip, Stack } from '@mui/material'
import ClearFileChip from '../ClearFileChip'

function checkFileExtension(track: string) {
  return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'svg', 'webp'].includes(
    track.split('.').slice(-1)[0].toLowerCase(),
  )
}

const PadImagePicker: React.FC<{
  imgSrc?: string
  onClear: () => void
  onImageSelected: (
    name: string,
    data: ArrayBuffer,
    selectedImage?: File,
  ) => void
  onError: (error: string) => void
}> = ({ imgSrc, onClear, onError, onImageSelected }) => {
  const inputFileRef = React.useRef<HTMLInputElement>(null)

  const [_imgSrc, setImgSrc] = React.useState('')
  const [selectedImage, setSelectedImage] = React.useState<File | null>(null)

  React.useEffect(() => {
    if (selectedImage) {
      const reader = new FileReader()
      reader.readAsDataURL(selectedImage)
      reader.onloadend = () => setImgSrc(reader.result as string)
    }
  }, [selectedImage])

  React.useEffect(() => {
    if (!selectedImage) return

    const reader = new FileReader()
    reader.onload = function () {
      if (!selectedImage)
        return console.debug('Failing to read because no image selected.')
      if (!checkFileExtension(selectedImage.name))
        return onError(
          'Supported file formats are: jpg, jpeg, png, gif, bmp, tiff svg, webp',
        )

      if (reader.result && reader.result !== null) {
        onImageSelected(
          selectedImage.name,
          reader.result as ArrayBuffer,
          selectedImage,
        )
      } else {
        return onError('Failed to read file')
      }
      setSelectedImage(null)
    }
    reader.readAsArrayBuffer(selectedImage)
  }, [selectedImage])

  return (
    <>
      <Box sx={{ pb: 2 }}>
        <Typography variant="body1">
          Select an image to show on the sound pad.
        </Typography>
      </Box>

      <Stack direction="row" gap="0.5rem">
        <UploadFileDropzoneChip
          accept=".jpg,.jpeg,.png,.gif,.bmp,.tiff,.svg,.webp"
          onClick={() => inputFileRef.current?.click()}
          label="Select Image"
        />
        <input
          ref={inputFileRef}
          style={{ display: 'none' }}
          accept=".jpg,.jpeg,.png,.gif,.bmp,.tiff,.svg,.webp"
          id="contained-button-file"
          type="file"
          onChange={(e) => {
            const f = (e.target.files || [])[0]
            setSelectedImage(f)
          }}
        />
        {imgSrc && (
          <ClearFileChip
            onClick={() => {
              setSelectedImage(null)
              onClear()
            }}
          />
        )}
      </Stack>

      {/* {imgSrc && (
        <Box sx={{ my: 3 }} maxWidth="600px">
          <img
            src={imgSrc}
            height="auto"
            width="auto"
            alt="Preview"
            style={{
              maxWidth: '100%',
              maxHeight: '300px',
              boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
            }}
          />
        </Box>
      )} */}
    </>
  )
}

export default PadImagePicker
